import React, { useState } from 'react'
import { Button, Form, Input, Modal, notification, Space } from 'antd'
import styled from 'styled-components'
import { UserAvatarWithName } from 'components'
import { CommentsService, DateFormat, DateUtility, FlagStatus } from 'utility'
import { StackPlus } from '@phosphor-icons/react'
import { StyledCloseIcon } from 'components/StyleCloseIcon'

const ReviewStyledModal = styled(Modal)`
  .ant-modal {
    font-family: 'DM Sans', sans-serif;
    top: 10px !important;
    overflow: hidden !important;
  }
  .ant-modal-body {
    height: 70vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 10px;
  }
  &.normal-height-modal {
    .ant-modal-body {
      height: auto !important;
      max-height: 80vh;
    }
  }

  .ant-modal-body::-webkit-scrollbar {
    width: 6px;
  }

  .ant-modal-body::-webkit-scrollbar-thumb {
    background-color: #b0b0b0;
    border-radius: 3px;
  }

  .ant-modal-body::-webkit-scrollbar-track {
    background: #f0f0f0;
  }
  .ant-modal-header {
    padding: 15px;
    padding-bottom: 13px;
    ${'' /* padding: 16px; */}
    border-bottom: 1px solid #e5e5e5;
  }

  .ant-modal-title {
    font-size: 18px;
    font-weight: bold;
  }
  .ant-modal-content {
    padding: 0;
  }

  .ant-modal-wrap {
    top: 10px !important;
    overflow: hidden !important;
  }
  .ant-modal-footer {
    display: flex;
    margin-top: 0;
    justify-content: space-between;
    padding: 20px 10px 20px;
  }
  .video-info {
    margin-bottom: 2px;
  }
  .video-title {
    font-size: 18px;
    font-weight: bold;
  }
  .creator {
    margin-top: 8px;
    font-weight: bold;
  }
  .report-info {
    margin-top: 16px;
    padding: 12px;
    background: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    border-radius: 5px;
  }
  .comment-box {
    // margin-top: 16px;
  }
  .footer-buttons {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }
`

const VideoSelectionMessage = styled.p`
  color: #1a1a1a;
  font-size: 18px;
  font-weight: bold;
  margin: 8px 10px;
`
const LabelWrapper = styled.span`
  font-size: 12px;
  color: #808080;
`
const LabelInfo = styled.h4`
  font-family: 'DM Sans', sans-serif;
  color: #1a1a1a;
  margin-top: 5px;
  font-size: 14px;
  font-weight: 600;
`
const FooterButtons = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
`

const FullWidthButton = styled(Button)`
  flex: 1;
  height: 45px;
  font-weight: bold;

  &:nth-child(2) {
    background-color: #ffecec;
    color: #d32f2f;

    &:hover {
      background-color: #ffd6d6;
    }
  }

  &:nth-child(1) {
    background-color: #e8edff;
    color: #5c67ca;
    border-color: #d6e0ff;

    &:hover {
      background-color: #d6e0ff;
    }
  }
`
export const ReviewFlaggedCommentModal = ({
  data,
  visible,
  onCancel,
  mode,
  refetch,
  selected,
  tab,
}) => {
  const [comment, setComment] = useState('')
  const [loading, setLoading] = useState(false)
  const handleRequest = async flag => {
    try {
      if (comment === '') {
        notification.warning({
          message: 'Comment is Required',
        })
        return
      }
      let tempData = null
      setLoading(true)
      if (mode === 'multiple') {
        tempData = {
          comment_ids: selected?.length === 1 ? selected[0] : selected,
          status: flag,
          flag_resolved_comment: comment,
        }
      } else {
        tempData = {
          comment_ids: data?._id,
          status: flag,
          flag_resolved_comment: comment,
        }
      }
      await CommentsService.resolveFlaggedComment(tempData)
      notification.success({
        message: 'Success!',
        description: `Request ${flag} successfully.`,
      })
      refetch()
    } catch (error) {
      notification.error({
        message: 'Error!',
        description: error || 'Failed to approve request.',
      })
    } finally {
      setComment('')
      onCancel()
      setLoading(false)
    }
  }

  return (
    <ReviewStyledModal
      title="Review flagged comments"
      visible={visible}
      onCancel={onCancel}
      closeIcon={<StyledCloseIcon>✖</StyledCloseIcon>}
      centered
      className={mode === 'multiple' ? 'normal-height-modal' : ''}
      footer={
        <FooterButtons>
          {(tab === 'approved' || tab === 'disapproved') && (
            <FullWidthButton
              disabled={loading || comment === ""}
              onClick={() => handleRequest(FlagStatus.FlagRequested)}
              type="primary"
              danger
            >
              Re-Evaluate Comment
            </FullWidthButton>
          )}
          {(tab === 'pending' || tab === 'disapproved') && (
            <FullWidthButton
              disabled={loading || comment === ""}
              onClick={() => handleRequest(FlagStatus.Flagged)}
              type="primary"
              danger
            >
              Remove Comment
            </FullWidthButton>
          )}
          {(tab === 'pending' || tab === 'approved') && (
            <FullWidthButton
              disabled={loading || comment === ""}
              onClick={() => handleRequest(FlagStatus.Active)}
              type="default"
            >
              Ignore Report
            </FullWidthButton>
          )}
        </FooterButtons>
      }
    >
      {mode === 'multiple' ? (
        <div className="video-info d-flex justify-content-center  align-items-center p-3">
          <StackPlus size={32} />{' '}
          <VideoSelectionMessage>
            Multiple Comments Selected
          </VideoSelectionMessage>
        </div>
      ) : (
        <Space
          direction="vertical"
          size="middle" // Increased from "small" to "middle" or use "large"
          className="mt-2"
          style={{ padding: '5px 20px', width: '100%' }} // Reduced right and left padding
        >
          <div className="d-flex flex-column gap-2">
            {' '}
            {/* Bootstrap spacing */}
            <div>
              <LabelWrapper>Comment:</LabelWrapper>
              <LabelInfo>{`"${data.text}"` || '-'}</LabelInfo>
            </div>
            <div className="d-flex flex-column gap-2">
              <LabelWrapper>Commenter:</LabelWrapper>
              <UserAvatarWithName
                id={data?.user?.fid}
                title={data?.user?.name}
                url={data?.user?.image}
              />
            </div>
            <div>
              <LabelWrapper>Reason:</LabelWrapper>
              <LabelInfo>{data?.flag_reason || '-'}</LabelInfo>
            </div>
            <div className="d-flex">
              <div className="w-50 pe-2">
                <LabelWrapper>Flagged by:</LabelWrapper>
                <LabelInfo>{data?.flagged_by?.name || '-'}</LabelInfo>
              </div>
              <div className="w-50 pe-2">
                <LabelWrapper>Flagged On:</LabelWrapper>
                <LabelInfo>
                  {DateUtility.formatDate(
                    new Date(data?.date),
                    DateFormat.DD_MM_YYYY_Time,
                  ) || '-'}
                </LabelInfo>
              </div>
            </div>
            <div>
              <LabelWrapper>Video:</LabelWrapper>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                  src={data?.video?.thumbnail_url}
                  alt="video thumbnail"
                  style={{
                    width: '30px',
                    height: '30px',
                    borderRadius: '2px',
                    objectFit: 'cover',
                  }}
                />
                <span style={{ marginLeft: '8px' }}>
                  {' '}
                  <LabelInfo>{data?.video?.title}</LabelInfo>
                </span>
              </div>
            </div>
          </div>
        </Space>
      )}
      <hr />
      <Form requiredMark="optional">
        {' '}
        <div className="comment-box" style={{ padding: '3px 20px' }}>
          <Form.Item
            label={
              <span>
                Comment <span style={{ color: 'red' }}>*</span>
              </span>
            }
            name="comment"
            rules={[{ required: true, message: 'This field is required' }]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Input
              placeholder="Enter your reason to approve or disapprove"
              value={comment}
              onChange={e => setComment(e.target.value)}
              style={{
                backgroundColor: '#fafafa',
                color: '#000',
                padding: '10px 12px', // Top-Bottom: 10px, Left-Right: 12px (default)
              }}
            />
          </Form.Item>
        </div>
      </Form>
    </ReviewStyledModal>
  )
}
